var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-loading d-flex justify-content-center align-items-center"},[_c('b-spinner',{attrs:{"type":"grow","label":_vm.$tc('global.spinner.loading'),"variant":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }